export const NEVER_WORKED_HERE = 'NEVER_WORKED_HERE'

type AuditTrailFinding = {
  infoCollected?: readonly string[] | null
} | null

export const hasNeverWorkedHereFinding = (
  auditTrailLogs?: readonly AuditTrailFinding[] | null
): boolean =>
  (auditTrailLogs ?? []).some((log) =>
    (log?.infoCollected ?? []).includes(NEVER_WORKED_HERE)
  )
